
import { useCallback } from 'react';
import { AdminState, AdminAction } from '@/types/adminTypes';

/**
 * Hook for recording admin actions
 */
export const useAdminActionRecording = (
  recordAdminAction: (
    actionType: AdminAction['actionType'],
    adminName: string,
    details?: string,
    attendeeCode?: string
  ) => Promise<any>,
  adminState: AdminState
) => {
  // Record admin action with increased throttling
  const recordAction = useCallback(
    async (
      actionType: AdminAction['actionType'],
      adminName: string,
      details?: string,
      attendeeCode?: string
    ) => {
      try {
        const result = await recordAdminAction(
          actionType,
          adminName,
          details,
          attendeeCode
        );
        
        // Check if the action was throttled
        if (result.error === 'throttled') {
          return { 
            error: 'throttled',
            updatedState: adminState
          };
        }
        
        const { newAction, updatedActions } = result;
        
        return { 
          newAction, 
          updatedActions, 
          updatedState: adminState 
        };
      } catch (error) {
        console.error('Error in recordAction:', error);
        
        const { newAction, updatedActions } = await recordAdminAction(
          actionType,
          adminName,
          details,
          attendeeCode
        );
        
        return { 
          newAction, 
          updatedActions, 
          updatedState: adminState 
        };
      }
    },
    [recordAdminAction, adminState]
  );
  
  return {
    recordAction
  };
};
